import { useEffect, useState } from "react";

import {
    addDoc,
    collection,
    getDocs
} from "firebase/firestore";

import { db } from "../../firebase/firebase";

import "../../assets/css/contactForm.css";


function ContactForm() {

    const [loading, setLoading] = useState(false);

    const [packages, setPackages] = useState([]);

    const [popup, setPopup] = useState({
        show: false,
        type: "",
        message: ""
    });


    /*=========================================================
                        CAMERA OPTIONS
    =========================================================*/

    const cameraOptions = [

        "Photography",
        "Traditional Photography",
        "Candid Photography",
        "Videography",
        "Traditional Videography",
        "Cinematic Videography",
        "Drone Camera",
        "4K Drone Camera",
        "Crane Camera",
        "LED Wall",
        "Live Streaming",
        "Photo Booth",
        "360° Video Booth",
        "Instant Photo Printing",
        "Instagram Reels Coverage"

    ];


    /*=========================================================
                        FORM STATE
    =========================================================*/

    const [form, setForm] = useState({

        name: "",
        email: "",
        phone: "",
        selectedPackages: [],
        selectedCameras: [],
        eventDate: "",
        message: ""

    });


    /*=========================================================
                        LOAD PACKAGES
    =========================================================*/

    useEffect(() => {

        const loadPackages = async () => {

            try {

                const snapshot = await getDocs(
                    collection(db, "packages")
                );

                const packageList = snapshot.docs.map((item) => ({

                    id: item.id,

                    ...item.data()

                }));

                setPackages(packageList);

            } catch (error) {

                console.error(
                    "Error loading packages:",
                    error
                );

            }

        };

        loadPackages();

    }, []);


    /*=========================================================
                        INPUT CHANGE
    =========================================================*/

    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm((previousForm) => ({

            ...previousForm,

            [name]: value

        }));

    };


    /*=========================================================
                    SCROLL PAGE TO TOP
    =========================================================*/

    const scrollToTopAfterSubmit = () => {

        // Browser window
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });


        // Main document
        if (document.documentElement) {

            document.documentElement.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });

        }


        // Body
        if (document.body) {

            document.body.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });

        }


        // React root
        const root = document.getElementById("root");

        if (root) {

            root.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });

        }


        // Customer contact page
        const page = document.querySelector(
            ".customer-contact-page"
        );

        if (page) {

            page.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });

        }

    };


    /*=========================================================
                        SHOW SUCCESS
    =========================================================*/

    const showSuccessPopup = () => {

        setPopup({

            show: true,

            type: "success",

            message:
                "Thank you! Your session request has been submitted successfully. We will contact you soon."

        });


        /*
         * Wait until React displays the popup,
         * then move the customer to the top.
         */
        setTimeout(() => {

            scrollToTopAfterSubmit();

        }, 200);


        /*
         * Hide popup after 5 seconds.
         */
        setTimeout(() => {

            setPopup({

                show: false,

                type: "",

                message: ""

            });

        }, 5000);

    };


    /*=========================================================
                        SHOW ERROR
    =========================================================*/

    const showErrorPopup = () => {

        setPopup({

            show: true,

            type: "error",

            message:
                "Sorry, we could not submit your request. Please try again."

        });


        setTimeout(() => {

            setPopup({

                show: false,

                type: "",

                message: ""

            });

        }, 5000);

    };


    /*=========================================================
                        SUBMIT FORM
    =========================================================*/

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (loading) {

            return;

        }

        setLoading(true);


        try {

            /*=================================================
                    SAVE DATA TO FIREBASE
            =================================================*/

            await addDoc(

                collection(db, "contacts"),

                {

                    name: form.name,

                    email: form.email,

                    phone: form.phone,

                    selectedPackages:
                        form.selectedPackages,

                    selectedCameras:
                        form.selectedCameras,

                    eventDate: form.eventDate,

                    message: form.message,

                    createdAt: new Date()

                }

            );


            /*=================================================
                    SUCCESS POPUP
            =================================================*/

            showSuccessPopup();


            /*=================================================
                    RESET FORM
            =================================================*/

            setForm({

                name: "",

                email: "",

                phone: "",

                selectedPackages: [],

                selectedCameras: [],

                eventDate: "",

                message: ""

            });


        } catch (error) {

            console.error(
                "Error submitting contact form:",
                error
            );

            showErrorPopup();

        } finally {

            setLoading(false);

        }

    };


    /*=========================================================
                            RETURN
    =========================================================*/

    return (

        <>

            {/*=================================================
                        SUCCESS / ERROR POPUP
            =================================================*/}

            {popup.show && (

                <div
                    className={`luxury-popup ${popup.type}`}
                >

                    <div className="popup-icon">

                        {popup.type === "success"
                            ? "✓"
                            : "✕"}

                    </div>


                    <div className="popup-content">

                        <h3>

                            {popup.type === "success"
                                ? "Booking Submitted"
                                : "Submission Failed"}

                        </h3>


                        <p>

                            {popup.message}

                        </p>

                    </div>

                </div>

            )}


            {/*=================================================
                            FORM
            =================================================*/}

            <form
                className="customer-contact-form"
                onSubmit={handleSubmit}
            >

                <h2>

                    Book Your Session

                </h2>


                <p>

                    Fill in your details and our team will get
                    back to you shortly.

                </p>


                {/*=================================================
                                NAME
                =================================================*/}

                <input

                    className="customer-contact-input"

                    type="text"

                    name="name"

                    placeholder="Full Name"

                    value={form.name}

                    onChange={handleChange}

                    required

                />


                {/*=================================================
                                EMAIL
                =================================================*/}

                <input

                    className="customer-contact-input"

                    type="email"

                    name="email"

                    placeholder="Email Address"

                    value={form.email}

                    onChange={handleChange}

                    required

                />


                {/*=================================================
                                PHONE
                =================================================*/}

                <input

                    className="customer-contact-input"

                    type="tel"

                    name="phone"

                    placeholder="Phone Number"

                    value={form.phone}

                    onChange={handleChange}

                    required

                />


                {/*=================================================
                            SELECT PACKAGES
                =================================================*/}

                <label className="customer-contact-label">

                    Select Packages

                </label>


                <div className="customer-options-grid">

                    {packages.map((pkg) => {

                        const checked =
                            form.selectedPackages.includes(
                                pkg.title
                            );


                        return (

                            <label

                                key={pkg.id}

                                className={
                                    `customer-option-card ${
                                        checked
                                            ? "active"
                                            : ""
                                    }`
                                }

                            >

                                <input

                                    type="checkbox"

                                    checked={checked}

                                    onChange={(e) => {

                                        if (
                                            e.target.checked
                                        ) {

                                            setForm(
                                                (previousForm) => ({

                                                    ...previousForm,

                                                    selectedPackages: [

                                                        ...previousForm.selectedPackages,

                                                        pkg.title

                                                    ]

                                                })
                                            );

                                        } else {

                                            setForm(
                                                (previousForm) => ({

                                                    ...previousForm,

                                                    selectedPackages:
                                                        previousForm.selectedPackages.filter(
                                                            (item) =>
                                                                item !==
                                                                pkg.title
                                                        )

                                                })
                                            );

                                        }

                                    }}

                                />


                                <span>

                                    {pkg.title}

                                </span>

                            </label>

                        );

                    })}

                </div>


                {form.selectedPackages.length > 0 && (

                    <div className="selected-packages">

                        <strong>

                            Selected Packages

                        </strong>

                        <p>

                            {form.selectedPackages.join(", ")}

                        </p>

                    </div>

                )}


                {/*=================================================
                            CAMERA SERVICES
                =================================================*/}

                <label className="customer-contact-label">

                    Select Camera Services

                </label>


                <div className="customer-options-grid">

                    {cameraOptions.map((camera) => {

                        const checked =
                            form.selectedCameras.includes(
                                camera
                            );


                        return (

                            <label

                                key={camera}

                                className={
                                    `customer-option-card ${
                                        checked
                                            ? "active"
                                            : ""
                                    }`
                                }

                            >

                                <input

                                    type="checkbox"

                                    checked={checked}

                                    onChange={(e) => {

                                        if (
                                            e.target.checked
                                        ) {

                                            setForm(
                                                (previousForm) => ({

                                                    ...previousForm,

                                                    selectedCameras: [

                                                        ...previousForm.selectedCameras,

                                                        camera

                                                    ]

                                                })
                                            );

                                        } else {

                                            setForm(
                                                (previousForm) => ({

                                                    ...previousForm,

                                                    selectedCameras:
                                                        previousForm.selectedCameras.filter(
                                                            (item) =>
                                                                item !==
                                                                camera
                                                        )

                                                })
                                            );

                                        }

                                    }}

                                />


                                <span>

                                    {camera}

                                </span>

                            </label>

                        );

                    })}

                </div>


                {form.selectedCameras.length > 0 && (

                    <div className="selected-packages">

                        <strong>

                            Selected Camera Services

                        </strong>

                        <p>

                            {form.selectedCameras.join(", ")}

                        </p>

                    </div>

                )}


                {/*=================================================
                            EVENT DATE
                =================================================*/}

                <label className="customer-contact-label">

                    Preferred Event Date

                </label>


                <input

                    className="customer-contact-input"

                    type="date"

                    name="eventDate"

                    value={form.eventDate}

                    onChange={handleChange}

                    required

                />


                {/*=================================================
                            MESSAGE
                =================================================*/}

                <label className="customer-contact-label">

                    Tell Us About Your Event

                </label>


                <textarea

                    className="customer-contact-textarea"

                    name="message"

                    placeholder="Share your event details, venue, timing, expectations or any special requests..."

                    value={form.message}

                    onChange={handleChange}

                    rows="6"

                    required

                />


                {/*=================================================
                            SUBMIT BUTTON
                =================================================*/}

                <button

                    className="customer-contact-button"

                    type="submit"

                    disabled={loading}

                >

                    {loading

                        ? "Sending Your Inquiry..."

                        : "Book Consultation"

                    }

                </button>

            </form>

        </>

    );

}

export default ContactForm;